import { jsx as n, jsxs as x } from "react/jsx-runtime";
import i, { useEffect as b } from "react";
import s, { css as e } from "styled-components";
import { h as A, j as O, b as P, a as N, i as G } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { a as q } from "../chunks/breakpoints.907eaecd.js";
import { a as w, R as H } from "../chunks/index.cff5baaf.js";
import { a as J, R as K, B as Q } from "../chunks/index.b09c00db.js";
import { RangoDatePicker as U } from "./DatePicker.js";
import { f as _ } from "../chunks/vendor_date_fns.7fc2f26f.js";
const W = s.div.withConfig({
  displayName: "RangoInputDate",
  componentId: "sc-jgtfmw-0"
})(["& *{margin:0;padding:0;}width:100%;display:flex;flex-direction:column;gap:var(--spacing-1x);position:relative;", " .react-datepicker{border:none;padding:0 var(--spacing-2x) var(--spacing-2x) var(--spacing-2x);box-sizing:border-box;box-shadow:0px 4px 16px -2px rgba(var(--color-grey-900-rgb) / var(--opacity-super-low));}.react-datepicker__triangle{display:none;}.rango-datepicker-popper{top:-32px !important;background-color:var(--elements-bg-color-01);", "}"], ({
  disabled: o
}) => o && e(["opacity:var(--opacity-low);pointer-events:none;"]), q.lg(e(["transform:translate(-8px,121px) !important;"]))), X = s.div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-jgtfmw-1"
})(["display:flex;flex-direction:column;gap:var(--spacing-1x);"]), Y = s.input.withConfig({
  displayName: "Input",
  componentId: "sc-jgtfmw-2"
})(["", " color:var(--text-placeholder-color);width:100%;min-width:212px;outline:none;border:none;box-sizing:border-box;border-radius:inherit;background-color:transparent;padding-left:var(--spacing-2x);padding-right:0px;height:var(--size-8x);", " ", " &:disabled{background-color:transparent;color:var(--disabled-placeholder-color);&::placeholder{color:var(--disabled-placeholder-color);}}&::placeholder{color:var(--text-placeholder-color);}", " ", ""], A, ({
  filled: o
}) => o && e(["color:var(--active-placeholder-color);"]), ({
  error: o
}) => !o && e(["&:focus-within:not(:active){color:var(--active-placeholder-color);}"]), ({
  clicked: o,
  error: r
}) => o && !r && e(["color:var(--active-placeholder-color);"]), ({
  error: o
}) => o && e(["color:var(--negative-placeholder-color);&::placeholder{color:var(--negative-placeholder-color);}"])), Z = s.label.withConfig({
  displayName: "Label",
  componentId: "sc-jgtfmw-3"
})(["", " color:var(--text-label-color);", " ", " ", ""], O, ({
  clicked: o
}) => o && e(["color:var(--active-label-color);"]), ({
  disabled: o
}) => o && e(["color:var(--disabled-label-color);"]), ({
  error: o
}) => o && e(["color:var(--negative-label-color);"])), F = s.div.withConfig({
  displayName: "Element",
  componentId: "sc-jgtfmw-4"
})(["height:var(--size-8x);width:100%;display:flex;align-items:center;border:var(--default-border-width) solid var(--elements-border-color);border-radius:var(--default-border-radius);box-sizing:border-box;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);", " ", " ", " ", " ", ""], ({
  clicked: o
}) => o && e(["border-color:var(--active-border-color);transition-property:all;transition-timing-function:var(--curve-productive-entrance);transition-duration:var(--duration-fast-02);outline:transparent;"]), ({
  disabled: o
}) => o && e(["border-color:var(--disabled-border-color);"]), ({
  error: o
}) => o && e(["border-color:var(--negative-border-color);& input{padding-right:var(--spacing-1x);}"]), ({
  error: o,
  clicked: r
}) => !o && !r && e(["&:focus-within:not(:active){", " outline-offset:2px;border-color:var(--active-border-color);}&:hover{", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}"], P, N), ({
  error: o,
  clicked: r
}) => o && !r && e(["&:hover{", " transition-timing-function:var(--curve-productive-entrance);}"], N)), oo = s.div.withConfig({
  displayName: "Icons",
  componentId: "sc-jgtfmw-5"
})(["height:100%;margin-right:var(--size-half);display:flex;align-items:center;", "{background-color:transparent;}", "{color:var(--elements-icon-color);}", " ", ""], J, w, ({
  disabled: o
}) => o && e(["", "{color:var(--disabled-icon-color);}"], w), ({
  error: o
}) => o && e(["", "{color:var(--negative-icon-color);}"], w)), eo = s.p.withConfig({
  displayName: "SupportText",
  componentId: "sc-jgtfmw-6"
})(["", " color:var(--text-support-text-color);", " ", ""], G, ({
  disabled: o
}) => o && e(["color:var(--disabled-support-text-color);"]), ({
  error: o
}) => o && e(["color:var(--negative-support-text-color);"])), ro = i.forwardRef(({
  clicked: o = !1,
  disabled: r,
  error: v = !1,
  filled: a = !1,
  ...f
}, t) => /* @__PURE__ */ n(Y, { ref: t, ...f, disabled: r, clicked: o, error: v, filled: a })), to = i.forwardRef(({
  label: o = "",
  disabled: r = !1,
  supportText: v = "",
  error: a = !1,
  buttonIconAriaLabel: f = "",
  selectsRange: t = !1,
  dateFormat: g = "dd/MM/yyyy",
  onChange: y,
  ...d
}, z) => {
  const [p, m] = i.useState(!1), [R, E] = i.useState(!1), [h, I] = i.useState(), [C, D] = i.useState(), [L, k] = i.useState(""), B = i.useRef(null);
  b(() => {
    d.startDate || j();
  }, [d.startDate]), b(() => {
    d.selectedDate || j();
  }, [d.selectedDate]), b(() => {
    S(h, C);
  }, [t]);
  const S = (l, c) => {
    if (l == null)
      return;
    const u = _(l, g), $ = c ? _(c, g) : "";
    k(t ? `${u} - ${$}` : u);
  }, M = (l) => {
    const [c, u] = Array.isArray(l) ? l : [l, null];
    E(c !== ""), I(c), D(u), S(c, u), y && y(t ? l : c);
  }, V = () => {
    m(!1);
  }, T = () => {
    m(!p);
  }, j = () => {
    I(null), D(null), k("");
  };
  return /* @__PURE__ */ n(W, { disabled: r, ref: z, children: /* @__PURE__ */ n(U, { popperClassName: "rango-datepicker-popper", inline: !1, ref: B, selectsRange: t, selectedDate: t ? null : h, startDate: t ? h : null, endDate: t ? C : null, dateFormat: g, onChange: M, onCalendarClose: V, customInput: /* @__PURE__ */ x(X, { children: [
    /* @__PURE__ */ n(Z, { clicked: p, error: a, disabled: r, children: o }),
    /* @__PURE__ */ x(F, { clicked: p, error: a, disabled: r, children: [
      /* @__PURE__ */ n(ro, { ...d, disabled: r, value: L, clicked: p, error: a, filled: R, onClick: T }),
      /* @__PURE__ */ x(oo, { disabled: r, error: a, children: [
        a && !r && /* @__PURE__ */ n(H, { icon: "NegativeLine" }),
        /* @__PURE__ */ n(K, { "aria-label": f, disabled: r, size: Q.LG, icon: "CalendarLine", onClick: () => m(!p) })
      ] })
    ] }),
    /* @__PURE__ */ n(eo, { disabled: r, error: a, children: v })
  ] }), ...d }) });
});
to.displayName = "RangoInputDate";
export {
  to as RangoInputDate
};
